module.exports = __webpack_public_path__ + "media/media/success/countries-31aee5b2021eb70558b0de5d511969b2.png";